import React from 'react';
import { Props } from './';

const grey = { color: '#CACACA' };

const ColoredField = ({ children, rowData, style }: Props) => {
  let actualStyle;
  if (style) {
    actualStyle = style;
  } else {
    if (rowData.status === 'PENDING') {
      actualStyle = grey;
    }
  }

  return <div style={actualStyle}>{children}</div>;
};

export default ColoredField;
